import * as React from 'react';

var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
var SvgOrders = function SvgOrders(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    "aria-hidden": "true",
    className: "orders_svg__icon orders_svg__icon--user"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M22.306 4.873c.57.228.944.78.944 1.393v11.469a1.5 1.5 0 0 1-.943 1.392l-9.749 3.9a1.5 1.5 0 0 1-1.116-.001l-9.703-3.898a1.5 1.5 0 0 1-.94-1.392V6.264a1.5 1.5 0 0 1 .94-1.392L11.44.98a1.5 1.5 0 0 1 1.116 0l9.751 3.894Z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M18.187 7.275 7.025 2.806M12.008 9.744 1.136 5.41M12 22.295V9.745M12.095 9.7l10.91-4.338M20.625 16.5l-1.875.75"
  })));
};

export { SvgOrders as default };
//# sourceMappingURL=orders.svg.js.map
